import { SmallPagePaper } from '~/common/components';
import { SignupForm } from '~/components/forms/SignupForm';

export const SignupPage = () => (
  <SmallPagePaper>
    <SignupForm />
  </SmallPagePaper>
);
